<template>
  <f7-list inline-labels no-hairlines-ios>
    <f7-list-item :title="$t('label.requestFrom')" :footer="request.created | toDateTime"
                  :after="requester">
      <f7-icon slot="media" f7="creditcard"/>
    </f7-list-item>
    <f7-list-item :title="$t('label.reason')"
                  :after="formatMoney(request.currency, request.amount)">
      <f7-icon slot="media" f7="money_pound_round"/>
      <div slot="footer">
        <div v-if="$store.state.beta.enabled">
          <tag-entry :value="request.tags" @set-tags="setTags"/>
        </div>
        <div v-else>
          {{request.reason}}
        </div>
      </div>
    </f7-list-item>
    <f7-list-item v-if="request.notes" :title="$t('label.notes')" :footer="request.notes">
      <f7-icon slot="media" f7="chat_bubble"/>
    </f7-list-item>
    <f7-list-item :title="$t('label.budgetFrom')" :footer="budget">
      <f7-icon slot="media" f7="chart_pie"/>
    </f7-list-item>
  </f7-list>
</template>

<script>
  import helpers from "@/utils/helpers";
  import TagChip from "@/components/TagChip";
  import TagEntry from '@/components/TagEntry'
  import api from 'aio-api'

  export default {
    name: "RequestCard",
    components: {TagEntry, TagChip},
    data: function () {
      return {
        tags: [],
      }
    },
    props: {
      request: {
        type: Object,
      },
    },
    computed: {
      hasTags () {
        return !!this.request.tags?.length
      },
      requester () {
        const user = this.myTeam.find(u => u.id === this.request.userId)
        return user ? this.userName(user) : ''
      },
      budget () {
        const budget = this.budgets.find(b => b.potId === this.request.potId)
        if (budget) {
          const balance = this.formatMoney(budget.currency, budget.balance)
          return this.isManaging && !this.isProcessed ? this.$t('title.balanceAvailable', {
            budget: budget.name,
            amount: balance
          }) : budget.name
        } else return ''
      },
      isApproved () {
        return this.request.status === 'approved'
      },
      isProcessed () {
        return !!this.request.status
      },
    },
    methods: {
      async setTags (tags) {
        await api.request.setTags(this.request.id, tags.map(t => t.name))
      },
    },
    mixins: [helpers],
  }
</script>

<style scoped>

</style>
